import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Section extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { className, styles } = this.props;

    const props = {
      id: this.props.id
    }
    
    return (
      <div {...props} className={`${className} full-height`} styles={[...styles]}>
        <article className="article container">
          {this.props.children}
        </article>
      </div>
    )
  }
}
Section.defaultProps = {
  className: 'regular',
  styles: {},
}

Section.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  styles: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/components/Section.js